export { SiteMap as default } from "./dtv-sitemap";
export type { SiteMapProps } from "./dtv-sitemap";
